import React from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router';
import useHomeData from './hookWorkSiteHome';
import { MainBox } from '10.quickConnect.app/components/domain/Declaration/styles';
import TopBar from '10.quickConnect.app/components/shared/LayOut/TopBar';

const HomeName = 'homeComponent';

const WorkSiteHome = () => {
  useHomeData();

  return (
    <Box data-cy={HomeName} sx={{ display: 'flex', flexDirection: 'column' }}>
      <TopBar pageTitle="" />
      <Box sx={MainBox}>
        <Outlet />
      </Box>

      {/* On ajoute la dialog concernant la prise en compte des pièces jointes */}
      {/*{sendAPI && <SendingAttachmentsDialog />}*/}
    </Box>
  );
};
export default observer(WorkSiteHome);
